<div class="content">
    <div class="content">
     <div class="container-fluid">
     <div class="row">
     <div class="col-lg-12 col-md-12 col-sm-12 common_title">
     <h2>MONTHLY CALCULATIONS</h2>
     <!--<p>Monthly Calculation List</p>-->
      <a [routerLink]="['/dashboard','Reportmanagement']" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
     </div>
     </div>
     <div class="row">
      <div class="col-lg-2 col-sm-3 col-12 " style="margin-top: 11px;">
        <div class="form-group" >
        <form enctype="application/x-www-form-urlencoded" role="form" autocomplete="off" >
          <fieldset>
            <date-range-picker [options]="" [controlName]="'rightDateRange'" aria-readonly="true"></date-range-picker>
          </fieldset>
        </form>
        </div>
       </div>
     <div class="col-lg-2 col-md-3 col-sm-12">
        <div class="form-group multiple">
        <label for="Species Name">Farm Name</label>
        <select  name="farmname" id="farmname" class="form-control selectpicker myFakeClass" >
          <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}</option>
        </select>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group">
          <label for="Species Name">Species Name</label>
          <select id="Speciesname" class="selectpicker form-control myFakeClass1" (change)="breedselectbyspecies($event)">
            <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
          </select>
          </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-12">
            <div class="form-group">
            <label for="Breed Name">Breed Name</label>
            <select id="BreedName" class="selectpicker form-control myFakeClass2">
              <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
            </div> 
            </div>
            <div class="col-lg-2 col-sm-3 col-12" >
              <div class="form-group">
                 <label for="Breed Name">Age</label>
                 <select id="age" class="selectpicker form-control myFakeClass3" >
                  <option *ngFor='let age_data of get_age' [value]="age_data.tnag_id">{{age_data.tnag_name}}({{age_data.tnag_time_range}}) </option>
                </select>
              </div>
             </div>
             <div class="col-lg-1 col-sm-3 col-12">
              <div class="form-group">
                <label for="Breed Name"></label>
                 <span class="input-group-btn">
                     <button class="btn btn-primary search" type="button" (click)="get_datas()" ><span class="fa fa-search"></span> Search</button>
                 </span>
                </div>
                
          </div>
          <div class="col-lg-1 col-sm-3 col-12" style="margin-top: 18px;">
            <div class="form-group">
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" (click)="exportdata()" ><span class="fa fa-download"></span></button>
              </span>
           </div>

          </div>
     </div>
     <div *ngIf="datatable==true" class="row">
     <div class="col-lg-12 col-md-12 col-sm-12">
    <!--loader start-->
  <div class="loading-div" *ngIf="isLoading">
    <div class="loading-bar">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p class="mt-3">Processing data. Please wait..</p>
    </div>
  </div>
    <!--loader end-->
     <table id="myTable" class="row-border hover" #table>
     <thead>
     <tr>
     <th>S.No</th>
     <th>Date</th>
     <th>Opening Balance</th>
     <th>Addition</th>
     <th>Opening Balance +Addition</th>
     <th>Death</th>
     <th>Deletion</th>
     <th>Daily Closing Balance</th>
     </tr>
     </thead>
     <tbody>
     <tr *ngFor="let reportData of getData;index as j" >
      <td>{{j + 1}}</td>
      <td>{{reportData.date}}</td>
      <td>{{reportData.opening_count}}</td>
      <td>{{reportData.additon_count}}</td>
       <td>{{reportData.total_count}}</td>
       <td>{{reportData.death_count}}</td>
       <td>{{reportData.deletion_count}}</td>
       <td>{{reportData.daily_closing_balance}}</td>
     </tr>
     <tr>
      <td>Total</td>
      <td></td>
      <td></td>
      <td>{{addtion_total}}</td>
       <td></td>
       <td>{{death_total}}</td>
       <td>{{deletion_total}}</td>
       <td>{{closing_total}}</td>
     </tr>
     <tr>
      <td colspan="7">Total number of animal days for the month </td>
       <td>{{closing_total}}</td>
     </tr>
     <tr>
      <td colspan="7">Total number of animals handled for the month (opening balance + Addition) </td>
       <td>{{opening_bal + addtion_total}}</td>
     </tr>
     </tbody>
     </table>
     </div>
     </div>
     <div class="row">

        <div  class="col-lg-4 col-md-6 col-sm-6">
          <a><div class="card card-stats reports"  style="cursor:pointer">
               <div class="card-header reports card-header-warning card-header-icon">
                <p class="card-category reports">Opening balance at start of month</p>
               </div>
               <div class="card-footer">
                <h4>{{opening_bal}}</h4>
                   </div>
           </div></a>
         </div>
         <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Addition</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{addtion_total}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Total number of animals handled</p>
               
                 </div>
                 <div class="card-footer">
                    <h4>{{opening_bal + addtion_total}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Deletion / Transfer</p>
       
                 </div>
                 <div class="card-footer">
                    <h4>{{deletion_total}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">No.Died within the duration</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{death_total}}</h4>
                       </div>
             </div></a>
           </div> 
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Closing balance at end of month</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{closing_balance_end}}</h4>
                       </div>
             </div></a>
           </div>

       </div>
       <div class="row">
       <div class="col-lg-8 col-md-8 col-sm-12 animaldaily">
        <p class="bottom">Animal days for this month</p>
          </div>
          <div  class="col-lg-4 col-md-4 col-sm-12 colord">
           <p class="bottomdiv">{{closing_total}}</p>
       </div >
       </div>
     
   </div>
 </div>
</div>